const state = {
    vacationList: [],
    leaveList: [],
    encashmentList: [],
    encashmentInfo: {},
    managedStaffList: [],
};

const getters = {
    vacationList: state => {
        return state.vacationList;
    },
    sickLeaveList: state => {
        return state.leaveList;
    },
    encashmentList: state => {
        return state.encashmentList;
    },
    encashmentInfo: state => {
        return state.encashmentInfo;
    },
    managedStaffList: state => {
        return state.managedStaffList;
    },
};

const mutations = {
    setVacationList(state, vacationList) {
        state.vacationList = vacationList;
    },
    setLeaveList(state, leaveList) {
        state.leaveList = leaveList;
    },
    setEncashmentList(state, encashmentList) {
        state.encashmentList = encashmentList;
    },
    setEncashmentInfo(state, encashmentInfo) {
        state.encashmentInfo = encashmentInfo;
    },
    setManagedStaffList(state, managedStaffList) {
        state.managedStaffList = managedStaffList;
    },
};

const actions = {
    async getStaffVacations({ commit }, { staffId, manager = false, year = null, leaveType = "vacation" }) {
        return new Promise(async (resolve, reject) => {
            try {
                const submit = manager ? 1 : 0;
                const response = (await axios.get("/admin/vacation/api/staff-vacation-requests/" + staffId, {
                    params: {
                        year: year,
                        submitted: submit,
                        type: leaveType,
                    },
                }));

                if (leaveType === "vacation") {
                    await commit("setVacationList", response.data.data);
                } else if (leaveType === "sick_leave" || leaveType === "sick") {
                    await commit("setLeaveList", response.data.data);
                }

                resolve(response);
            } catch (error) {
                reject(error);
            }
        });
    },
    async sendVacationRequest({ commit, dispatch }, payload) {
        return new Promise(async (resolve, reject) => {
            try {
                const formData = payload.formData;
                const response = (await axios.post("/admin/vacation/api/send-vacation-request",
                    formData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    }));
                await resolve(response.data);
            } catch (error) {
                console.log(error);
                reject();
            }
        });
    },
    async submitRequest({ commit, dispatch }, { id, type = null }) {
        return new Promise(async (resolve, reject) => {
            try {
                const response = (await axios.post(`/admin/vacation/api/submit-request/${id}`, {
                    type: type,
                }));
                await resolve(response.data);
            } catch (error) {
                console.log(error);
                reject();
            }
        });
    },
    async cancelRequest({ commit, dispatch }, payload) {
        return new Promise(async (resolve, reject) => {
            try {
                const response = (await axios.post(`/admin/vacation/api/cancel-request/${payload.id}`));
                await resolve(response.data);
            } catch (error) {
                console.log(error);
                reject();
            }
        });
    },
    async cancelEncashmentRequest({ commit, dispatch }, payload) {
        return new Promise(async (resolve, reject) => {
            try {
                const response = (await axios.post(`/admin/vacation/api/cancel-encashment-request/${payload.id}`));
                await resolve(response.data);
            } catch (error) {
                console.log(error);
                reject();
            }
        });
    },
    async getStaffEncashments({ commit }, { staffId, year = null }) {
        return new Promise(async (resolve, reject) => {
            try {
                const response = (await axios.get("/admin/vacation/api/staff-encashment-requests/" + staffId, {
                    params: {
                        year: year,
                    },
                }));
                await commit("setEncashmentList", response.data.data.encashmentList);
                await commit("setEncashmentInfo", response.data.data.encashmentInfo);
                resolve(response);
            } catch (error) {
                reject(error);
            }
        });
    },
    async sendEncashmentRequest({ commit, dispatch }, payload) {
        return new Promise(async (resolve, reject) => {
            try {
                const response = (await axios.post("/admin/vacation/api/send-encashment-request",
                    {
                        "encash_days": payload.encash_days,
                        "staff_id": payload.staff_id,
                        "year": payload.year,
                    }));

                await resolve(response.data);
            } catch (error) {
                console.log(error);
                reject();
            }
        });
    },
    async getManagedStaffList({ commit }, { manager_id }) {
        return new Promise(async (resolve, reject) => {
            try {
                const response = (await axios.get("/admin/vacation/api/managed-staff-list/" + manager_id));
                await commit("setManagedStaffList", response.data.data);
                await resolve(response.data);
            } catch (error) {
                reject(error);
            }
        });
    },
    async managerUpdateRequest({ commit, dispatch }, { type, id, status }) {
        return new Promise(async (resolve, reject) => {
            try {
                const response = (await axios.post(`/admin/vacation/api/manager-update-request`,
                    {
                        "id": id,
                        "status": status,
                        "type": type,
                    }));

                await resolve(response.data);
            } catch (error) {
                console.log(error);
                reject();
            }
        });
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
